module.exports = __webpack_public_path__ + "img/bg.745e4d87.png";